export const marketingPreferencesAcknowledged = state => state.myAccount.preferencesAcknowledged;
